import React from "react";
import Grid from "../../GridCards/Grid";
const Contabilidad = () => {
  return <Grid />;
};

export default Contabilidad;
